// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/typographyStyle
import { section, title } from 'styles/jss/original/base';

const styles = {
  section: {
    ...section,
    '@media (max-width: 640px)': {
      padding: '0 0 20px'
    }
  },
  title,
  step: {
    ...title,
    marginBottom: '10px'
  }
};

export default styles;
